import { getArticuloByReference, type InfoArticulo, type KitComponente } from "@/hooks/Api/KitsFabricacion";
import { useCallback, useState } from "react";
import { notificacionTipo } from "../Alerts";
import style from "./FormAddComponenteKit.module.css";

interface FormComponenteProps {
	readonly nombreConjunto: string;
	readonly componentes: KitComponente[];
	readonly addComponente: (componente: InfoArticulo, cantidad: number, cantidadDivisor: number) => void;
}
export function FormComponente(props: FormComponenteProps) {
	const [adding, setAdding] = useState(false);
	const { nombreConjunto, componentes, addComponente } = props;

	const onSubmit = useCallback(async (e: React.SubmitEvent<HTMLFormElement>) => {
		e.preventDefault();
		e.stopPropagation();
		const form = e.currentTarget;
		const formData = new FormData(form);
		const value = {
			referencia: formData.get("referencia") as string,
			cantidadPorUnidad: parseFloat(formData.get("cantidad") as string),
			cantidadDivisor: parseInt(formData.get("cantidadDivisor") as string),
		};

		if (isNaN(value.cantidadPorUnidad) || value.cantidadPorUnidad <= 0) {
			notificacionTipo("error", "La cantidad debe ser un número válido y mayor que 0.");
			return false;
		}

		if (isNaN(value.cantidadDivisor) || value.cantidadDivisor <= 0) {
			notificacionTipo("error", "La cantidad del divisor debe ser un número válido y mayor que 0.");
			return false;
		}

		const articulo = await getArticuloByReference(value.referencia);
		if (!articulo.exists) {
			notificacionTipo("error", "La referencia de artículo no es válida o no se ha encontrado.");
			return false;
		}

		if (componentes.some(comp => comp.idComponente == articulo.id)) {
			notificacionTipo("error", "Este componente ya ha sido agregado.");
			return;
		}

		addComponente(articulo, value.cantidadPorUnidad, value.cantidadDivisor);

		form.reset();
		setAdding(false);
	}, [componentes, addComponente]);


	return (
		<div style={{ borderTop: "1px solid black" }} id="contenedorAddComponente">
			<div style={{ display: adding ? "none" : undefined }}>
				<button style={{ width: "100%", border: "none", padding: "8px 10px" }} type="button" onClick={() => setAdding(true)}>
					Añadir Componente
				</button>
			</div>
			<div style={{ display: !adding ? "none" : undefined }}>
				<form onSubmit={(e) => void onSubmit(e)} className={style.formAddComponente}>
					<div>
						<span>Se usarán</span>
						<input name="cantidad" type="number" min={0.01} step={0.01} required />
						<span>unidades de</span>
						<input name="referencia" type="text" placeholder="######" required />
						<span>para </span>
					</div>
					<div>
						<span> cada</span>
						<input name="cantidadDivisor" type="number" min={1} step={1} required defaultValue={1} />
						<span> unidades de {nombreConjunto}</span>
					</div>

					<button type="submit" >+</button>
				</form>
			</div >
		</div >
	);

}